// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    padding-top: 30px;
}

.copyright-wrap {
    border-top: 1px solid var(--gordons-green-bright);
    margin-top: 50px;
    padding-top: 24px;
    padding-bottom: 24px;
}

.body-02.copyright-title {
    text-align: center;
}

@media screen and (max-width: 991px) {
    .footer-wrap {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column;
    }

    .footer-right-wrap {
        justify-content: space-between;
    }
}

@media screen and (max-width: 767px) {
    .footer-left-wrap {
        width: 80%;
    }

    .footer-right-wrap {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
    }
}

@media screen and (max-width: 479px) {
    .footer {
        padding-top: 30px;
        margin-top: 0;
        padding-bottom: 0;
    }

    .footer-wrap {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
    }

    .footer-left-wrap {
        width: 95%;
    }

    .footer-right-wrap {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        flex-direction: column;
    }

    .copyright-wrap {
        margin-top: 0;
        padding-top: 10px;
    }

    .body-03.footer-text-1 {
        margin-top: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Footer.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".footer {\n    padding-top: 30px;\n}\n\n.copyright-wrap {\n    border-top: 1px solid var(--gordons-green-bright);\n    margin-top: 50px;\n    padding-top: 24px;\n    padding-bottom: 24px;\n}\n\n.body-02.copyright-title {\n    text-align: center;\n}\n\n@media screen and (max-width: 991px) {\n    .footer-wrap {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column;\n    }\n\n    .footer-right-wrap {\n        justify-content: space-between;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .footer-left-wrap {\n        width: 80%;\n    }\n\n    .footer-right-wrap {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n    }\n}\n\n@media screen and (max-width: 479px) {\n    .footer {\n        padding-top: 30px;\n        margin-top: 0;\n        padding-bottom: 0;\n    }\n\n    .footer-wrap {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n    }\n\n    .footer-left-wrap {\n        width: 95%;\n    }\n\n    .footer-right-wrap {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        flex-direction: column;\n    }\n\n    .copyright-wrap {\n        margin-top: 0;\n        padding-top: 10px;\n    }\n\n    .body-03.footer-text-1 {\n        margin-top: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
